import { fetchDataFromBackend } from "../api/api";
import { SummaryEmployeeDTO } from "../DTOs/summaryEmployeeDTO";
import logger from "../core/utils/logger";

const isSimulation= import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

// Helper to generate fake data
function generateSimulatedSummaryEmployees(count = 100) {
    const employees = [];

    for (let i = 1; i <= count; i++) {
        const userId = `user-${i}`;
        const userName = `User ${i}`;
        const email= `test${i}@test.com`;
        const remainingHolidays = Math.floor(Math.random() * 30); // Random holidays
        const remainingOvertime = Math.floor(Math.random() * 40); // Random overtime

        const summaryCalendarEmployees = [];
        for (let week = 1; week <= 4; week++) {
            summaryCalendarEmployees.push({
                year: 2025,
                weekCalendarNumber: week,
                actualWorkTimeHours: Math.floor(Math.random() * 41), // 0–40
                actualWorkTimeMinutes: Math.floor(Math.random() * 60), // 0–59
                shouldWorkTimeHours: 40,
                shouldWorkTimeMinutes: 0,
                actualHolidayDays: Math.floor(Math.random() * 10),
                shouldHolidayDaysInYear: 30
            });
        }

        employees.push(
            new SummaryEmployeeDTO({
                userId,
                userName,
                email,
                remainingHolidays,
                remainingOvertime,
                summaryCalendarEmployees
            })
        );
    }

    return employees;
}


export const SummaryEmployeeService = {
    async getSummaryListEmployee() {
        try {
            if (isSimulation) {
                logger.log("Simulation mode active: Generating 100 simulated summary employee entries.");
                const simulatedData = generateSimulatedSummaryEmployees(100);
                return simulatedData;
            }
            logger.log("Fetching summary employee data from backend...");
            const response = await fetchDataFromBackend(`/SummaryEmployee/GetSummaryEmployees`, {skipAuth: false, method: 'get'});
            logger.log("Summary employee response:", JSON.stringify(response));
            var result = response.map(item=>new SummaryEmployeeDTO(item));
            logger.log("Summary employee Result:", JSON.stringify(result));
            return result;
        } catch (error) {
            logger.error("Error getting summary employee:", error);
            throw error;
        }
    },
   
};